class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    // Open the mega-menu on hover instead of requiring a click, on desktop pointer
    // devices. Touch devices (no hover) keep the original click-to-open behaviour.
    if (window.matchMedia('(min-width: 990px) and (hover: hover)').matches) {
      const summary = this.querySelector('summary');
      this.addEventListener('mouseenter', () => {
        clearTimeout(this.closeTimer);
        if (!this.mainDetailsToggle.open) {
          this.mainDetailsToggle.setAttribute('open', '');
          summary.setAttribute('aria-expanded', true);
        }
      });
      this.addEventListener('mouseleave', () => {
        this.closeTimer = setTimeout(() => this.close(), 300);
      });
      // Let hover drive open/close so a mouse click doesn't toggle it shut.
      // Keyboard activation (event.detail === 0) still toggles, for accessibility.
      // A heading that is also a link (Shop -> its page, 29/10/2026) is followed when clicked.
      summary.addEventListener('click', (event) => {
        if (event.detail !== 0 && !event.target.closest('a[href]')) event.preventDefault();
      });
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
